<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption"
                       :data="tableData"
                       :table-loading="tableLoading"
                       :page="page"
                       ref="crud"
                       @search-change="searchChange"
                       @refresh-change="refreshChange"
                       @row-save="handleSave"
                       @row-update="handleUpdate"
                       @size-change="pageSizeChange"
                       @current-change="pageChange">

                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary"
                               icon="el-icon-plus"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_CUSTOMER_STATUS_ADD"
                               @click.stop="handleAdd()"
                    >新增
                    </el-button>
                    <el-button type="warning"
                               icon="el-icon-check"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_CUSTOMER_STATUS_DEL"
                               @click.stop="handleDel('DELETE_OPTION','逻辑删除')">删除
                    </el-button>
                    <el-button type="danger"
                               icon="el-icon-check"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_CUSTOMER_STATUS_DEL_TRUE"
                               @click.stop="handleDel('DELETE_OPTION','物理删除')">物理删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="success"
                               icon="el-icon-view"
                               size="small"
                               plain
                               @click.stop="handleDetail(scope.row,scope.index)"
                    >查看</el-button>
                    <el-button type="primary"
                               icon="el-icon-check"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_CUSTOMER_STATUS_EDIT"
                               @click.stop="handleEdit(scope.row,scope.index)">编辑
                    </el-button>
                </template>
                <template slot-scope="scope" slot="contentListForm">
                    <el-table
                            :data="contentList"
                            border>
                        <el-table-column
                                prop="remindContent"
                                align="center"
                                label="提醒内容">
                            <template slot-scope="scope">
                                <el-input type="input" name="remindContent" v-model="scope.row.remindContent" :value="scope.row.remindContent"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="remindUser"
                                align="center"
                                label="提醒用户">
                            <template slot-scope="scope">
                                <el-radio-group v-model="scope.row.remindUser" :value="scope.row.remindUser">
                                    <el-radio-button key="value" v-for="remindUser in remindUsers" :label="remindUser.value">{{remindUser.label}}</el-radio-button>
                                </el-radio-group>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="操作">
                            <template slot-scope="scope">
                                <el-button type="warning" icon="el-icon-check" size="small" @click="handleSteppingDelete(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin-top: 20px">
                        <el-button @click="handleAddRows()">增加一行</el-button>
                    </div>
                </template>
            </avue-crud>

        </basic-container>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {customerStatusTableOption} from "@/const/salesCloud/customerStatusOption.js";
    import {
        findCustomerStatus,
        addCustomerStatus,
        editCustomerStatus,
        delCustomerStatus
    } from "@/api/salesCloud/customerStatus"
    import {findByLabel} from "@/util/util"
    import {DIC} from "@/const/dic"

    export default {
        name: "customerStatus",
        components: {},
        data() {
            return {
                tableOption: customerStatusTableOption, //表格设置属性
                tableData: [], //表格的数据
                tablePage: 1,
                tableLoading: false,
                tabelObj: {},
                page: {
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 //每页显示多少条
                },
                contentList:[],
                remindUsers:DIC.CUSTOMER_STATUS_USER_TYPE
            };
        },
        created() {
            this.handleList();
        },
        watch: {},
        mounted() {
        },
        computed: {
            ...mapGetters(["permission"])
        },
        props: [],
        methods: {
            handleAddRows(){
                var list = {
                    remindContent: "",
                    remindUser: "CUSTOMER"
                };
                this.contentList.unshift(list)
            },
            handleSteppingDelete(index, row){
                this.contentList.splice(index, 1);
            },
            pageSizeChange(pageSize) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage,
                    params.size = pageSize
                findCustomerStatus(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: pageSize
                    };
                    this.tableLoading = false;
                })
            },
            pageChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page
                params.size = this.page.pageSize
                findCustomerStatus(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            searchChange(params) {
                this.tableLoading = true;
                // let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage
                params.size = this.page.pageSize
                findCustomerStatus(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                })
            },
            refreshChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page.currentPage
                params.size = page.pageSize
                findCustomerStatus(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page.currentPage,
                        pageSize: page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            handleDetail(row, index){
                this.contentList = row.contentList
                this.$refs.crud.rowView(row, index)
            },
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd() {
                this.contentList = []
                this.$refs.crud.rowAdd();
            },
            handleEdit(row, index) {
                this.contentList = row.contentList
                this.$refs.crud.rowEdit(row, index);
            },
            /**
             * @title 获取数据
             * @detail 赋值为tableData表格即可
             *
             **/
            handleList() {
                this.tableLoading = true;
                let parmas = {
                    page: this.page.currentPage,
                    size: this.page.pageSize
                }
                findCustomerStatus(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 数据添加
             * @param row 为当前的数据
             * @param done 为表单关闭函数
             *
             **/
            handleSave(row, done) {
                row.contentList = this.contentList
                addCustomerStatus(row).then(response => {
                    if (response.code == '200') {
                        this.$message({
                            showClose: true,
                            message: "添加成功",
                            type: "success"
                        });
                        this.handleList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error"
                        })
                    }

                }).catch(error => {
                    this.loading = false
                    this.$message({
                        showClose: true,
                        message: error,
                        type: "error"
                    })
                })
                done();
            },
            /**
             * @title 数据删除
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             *
             **/
            handleDel(dicName, label) {
                if (this.$refs.crud.tableSelect.length == 0) {
                    this.$message({
                        showClose: true,
                        message: "请选择要操作的数据",
                        type: "error"
                    })
                    return
                }

                this.$confirm(`是否确认删除?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        let ids = new Array();
                        for (let row of this.$refs.crud.tableSelect) {
                            ids.push(row.id)
                        }

                        delCustomerStatus(findByLabel(DIC.DELETE_OPTION, label), ids).then(response => {
                            if (response.code == '200') {
                                this.$message({
                                    showClose: true,
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.handleList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.message,
                                    type: "error"
                                })
                            }

                        }).catch(error => {
                            this.loading = false
                            this.$message({
                                showClose: true,
                                message: error,
                                type: "error"
                            })
                        })
                    })
                    .catch(() => {
                    });

            },
            /**
             * @title 数据更新
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             * @param done 为表单关闭函数
             *
             **/
            handleUpdate(row, index, done) {
                row.contentList = this.contentList
                editCustomerStatus(row).then(response => {
                    if (response.code == '200') {
                        this.$message({
                            showClose: true,
                            message: "添加成功",
                            type: "success"
                        });
                        this.handleList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error"
                        })
                    }

                }).catch(error => {
                    this.loading = false
                    this.$message({
                        showClose: true,
                        message: error,
                        type: "error"
                    })
                })
                done();
            }
        }
    };
</script>

<style lang="scss">
    .table-container {
        padding: 8px 10px;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
